// export { default } from "./pages/EditRastreamento";
import EditRastreamento from "./pages/EditRastreamento";

export default EditRastreamento;